/**
 * Checks if the given URL is an internal URL (starts with '#' or '/').
 *
 * This function is a simple heuristic and may not cover all cases of internal vs. external URLs, which is why it is
 * deprecated in favor of `isLinkOut` for more accurate link checking.
 *
 * @param url - The URL to check.
 * @returns True if the URL is internal, false otherwise.
 * @deprecated This function is deprecated. Please use `isLinkOut` instead for a more accurate check of external links,
 * as it properly handles URL parsing and comparison of hosts, while this function only checks for simple prefixes and
 * may not cover all cases of internal vs. external URLs.
 */
export function isInternalUrl(url: string) {
  return url.startsWith('#') || url.startsWith('/');
}
